// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_dGh","cls2":"SearchOnboardingOverhaul-cls2_R0E SearchOnboardingOverhaul-cls1_dGh","fullWidth":"SearchOnboardingOverhaul-fullWidth_x_u"};